const getEnvVar = (key, fallback = '') => process.env[`REACT_APP_${key}`] || fallback;

export const footerBrand = {
  displayName: getEnvVar('COMPANY_NAME', 'Evaluate Yourself'),
  legalName: getEnvVar('COMPANY_LEGAL_NAME', 'Evaluate Yourself'),
  tagline: getEnvVar(
    'COMPANY_TAGLINE',
    'Realistic AI interview practice with structured feedback for communication, reasoning, confidence, and role readiness.'
  ),
};

export const footerSections = [
  {
    title: 'Product',
    links: [
      { label: 'Interview Setup', href: '/interview-config' },
      { label: 'Interview Tracks', href: '/tracks' },
      { label: 'Live Interview', href: '/interview-config' },
      { label: 'Reports', href: '/history' },
      { label: 'Pricing', href: '/pricing' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Technical Interviews', href: '/tracks' },
      { label: 'Behavioural Interviews', href: '/tracks' },
      { label: 'Interview Guides', href: '/presentation' },
      { label: 'Communication Practice', href: '/communication-practice' },
      { label: 'Support', href: getEnvVar('SUPPORT_URL', 'mailto:support@evaluateyourself.ai') },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Contact', href: getEnvVar('SUPPORT_URL', 'mailto:support@evaluateyourself.ai') },
    ],
  },
  {
    title: 'Account',
    links: [
      { label: 'Sign In', href: '/login' },
      { label: 'Register', href: '/register' },
      { label: 'Dashboard', href: '/dashboard' },
    ],
  },
];

export const footerLegalLinks = [
  { label: 'Privacy Policy', href: getEnvVar('PRIVACY_URL') },
  { label: 'Terms of Service', href: getEnvVar('TERMS_URL') },
].filter((link) => link.href);

export const footerLinks = footerSections.flatMap((section) => section.links);
